import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { oratricslogo } from "../../Assets/index"; // Assuming this path is correct
import { ChevronDownIcon, ChevronUpIcon ,HomeIcon, UserIcon,CubeIcon, ClipboardDocumentListIcon, CalendarDaysIcon, BookOpenIcon, ChartBarIcon, PaintBrushIcon, PencilIcon, StarIcon, CheckCircleIcon, GiftIcon, XMarkIcon } from "@heroicons/react/24/outline";
import "./Navbar.css";
import { BookOnline } from "@mui/icons-material";

const menuItems = [
  { text: "Dashboard", icon: HomeIcon, path: "/", iconColor: "#6644CC" },
  { text: "Profile", icon: UserIcon, path: "/profile", iconColor: "#28C76F" },
  { text: "Class Summary", icon: ClipboardDocumentListIcon, path: "/course", iconColor: "#FFC107" },
  { text: "Attendance History", icon: CalendarDaysIcon, path: "/attendance", iconColor: "#FF6B6B" },
  // { text: "My Curriculum", icon: BookOpenIcon, path: "/curriculum", iconColor: "#00BCD4" },
  { text: "Daily Performance", icon: ChartBarIcon, path: "/DailyPerformance", iconColor: "#FF5722" },
  {
    text: "Activity Classes",
    icon: PaintBrushIcon,
    iconColor: "#795548",
    submenu: [
      { text: "Activity Class", path: "/activityclass", icon: CheckCircleIcon, iconColor: "#4CAF50" },
      { text: "Saved Activity Classes", path: "/viewnotes", icon: PencilIcon, iconColor: "#673AB7" },
    ],
  },
  { text: "Quiz", icon: PencilIcon, path: "/quiz", iconColor: "#8BC34A" },
    { text: "GameZone", icon: CubeIcon, path: "/game", iconColor: "#6644CC" },
    { text: "Homework", icon: BookOnline, path: "/homework", iconColor: "#6df44A" },

  { text: "Achievements", icon: StarIcon, path: "/achivement", iconColor: "#FFEB3B" },
  { text: "My Rewards", icon: GiftIcon, path: "/reward", iconColor: "#009688" },
    { text: "Help", icon: CheckCircleIcon, path: "/help", iconColor: "#E91E63" },

];

const Navbar = ({ isCollapsed, isMobileOpen, onCloseMobile }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("User");
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState({});

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.name) {
      setUserName(user.name);
    }
  }, []);

  useEffect(() => {
    if (isCollapsed) {
      setOpenSubMenu({}); // Close all submenus when sidebar collapses
    }
  }, [isCollapsed]);

  const handleMenuItemClick = (path, hasSubMenu, text) => {
    if (hasSubMenu) {
      setOpenSubMenu((prev) => ({
        ...prev,
        [text]: !prev[text],
      }));
    } else {
      navigate(path);
      if (isMobileOpen) {
        onCloseMobile();
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
    setOpenLogoutDialog(false);
  };

  return (
    <nav
      className={`sidebar bg-white shadow-glass flex flex-col p-1  ${
        isCollapsed ? "collapsed" : ""
      } ${isMobileOpen ? "open-mobile" : ""}`}
    >
     <div className="flex items-center justify-center mb-3 lg:mb-4">
  <img
    src={oratricslogo}
    alt="oratrics"
    className={`flex-shrink-0 transition-all duration-300 ${
      isCollapsed ? "w-15 h-15 rounded-full bg-white shadow-md" : "w-auto h-14"
    }`}
  />
</div>


      <div className="flex-grow overflow-y-auto scrollbar-thin">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <React.Fragment key={item.text}>
              <li>
                <button
                  className={`flex items-center w-full space-x-3 p-3 rounded-xl hover:bg-indigo-50 transition-all duration-200 ${
                    pathname === item.path
                      ? "bg-indigo-100 text-primary-dark font-semibold"
                      : "text-gray-700"
                  }`}
                  onClick={() => handleMenuItemClick(item.path, !!item.submenu, item.text)}
                >
                  <item.icon
                    className="w-5 h-5 flex-shrink-0"
                    style={{ color: item.iconColor }}
                  />
                  <span className="sidebar-text text-gray-800 font-medium flex-grow text-left">
                    {item.text}
                  </span>
                 {item.submenu && (
  <ChevronDownIcon
    className={`w-5 h-5 text-gray-600 transition-transform duration-300 flex-shrink-0 ${
      openSubMenu[item.text] ? "rotate-180" : ""
    }`}
  />
)}

                </button>
              </li>
              {item.submenu && openSubMenu[item.text] && (
                <ul className="pl-6 space-y-2 animate-slide-down">
                  {item.submenu.map((subItem) => (
                    <li key={subItem.text}>
                      <button
                        className={`flex items-center w-full space-x-3 p-2 rounded-lg hover:bg-indigo-50 transition-all duration-200 ${
                          pathname === subItem.path
                            ? "bg-indigo-100 text-primary-dark font-semibold"
                            : "text-gray-700"
                        }`}
                        onClick={() => handleMenuItemClick(subItem.path, false)}
                      >
                        <subItem.icon
                          className="w-6 h-6 flex-shrink-0"
                          style={{ color: subItem.iconColor }}
                        />
                        <span className="sidebar-text text-gray-700 flex-grow text-left">
                          {subItem.text}
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </React.Fragment>
          ))}
        </ul>
      </div>

      <div className="mt-auto pt-6 border-t border-gray-200">
        <div className="flex items-center space-x-3 p-3 rounded-xl hover:bg-indigo-50 transition-all duration-200">
          <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-lg font-bold text-white shadow-md">
            {userName.charAt(0)}
          </div>
          <div className="sidebar-text">
            <p className="font-semibold text-gray-800">{userName}</p>
            <p className="text-sm text-gray-600">Learner</p>
          </div>
        </div>
        {/* <button
          className="flex items-center space-x-3 p-3 w-full bg-accent-1 text-white rounded-xl hover:bg-red-600 transition-all duration-200 shadow-md"
          onClick={() => setOpenLogoutDialog(true)}
        >
          <svg
            className="w-7 h-7 flex-shrink-0"
            fill="none"
            stroke="white"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 16.5V19C15 20.1046 14.1046 21 13 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3H13C14.1046 3 15 3.89543 15 5V8.0625M11 12H21M21 12L18.5 9.5M21 12L18.5 14.5"
            />
          </svg>
          <span className="sidebar-text font-semibold">Logout</span>
        </button> */}
      </div>

      {openLogoutDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fade-in">
          <div className="bg-white p-6 rounded-xl shadow-glass max-w-sm w-full">
            <h3 className="text-lg font-semibold mb-4 text-gray-800">
              Confirm Logout
            </h3>
            <p className="text-gray-600 mb-6">Are you sure you want to log out?</p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
                onClick={() => setOpenLogoutDialog(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-accent-1 text-white rounded-lg hover:bg-red-600 transition-colors"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;